import * as React from "react";
import i18n from "i18n";
import { Tooltip, withStyles } from "@material-ui/core";
import { Error as ErrorIcon } from "@material-ui/icons";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { ModelMap } from "modules/modelMap/models/ModelMap";

const styles = () => ({
  root: { cursor: "pointer" },
  iconContainer: { paddingLeft: 40, height: 30, float: "left" as any },
  icon: {
    color: "#FB4436",
    padding: 2,
    margin: 5,
    fontSize: 20,
  },
  labelContainer: {
    color: "#737373",
    height: 30,
    lineHeight: "30px",
    fontSize: 11,
  },
  label: {
    textOverflow: "ellipsis",
    width: 150,
    overflow: "hidden",
    whiteSpace: "nowrap" as any,
  },
});

const Row = withStyles(styles)(
  ({
    classes,
    property,
    onClick,
  }: {
    classes: any;
    property: string;
    onClick: () => void;
  }) => (
    <div className={classes.root} onClick={onClick}>
      <div className={classes.iconContainer}>
        <ErrorIcon className={classes.icon} />
      </div>
      <div className={classes.labelContainer}>
        <Tooltip title={property}>
          <div className={classes.label}>{property}</div>
        </Tooltip>
      </div>
    </div>
  )
);

interface IProps {
  modelMap: FirebaseDocument<ModelMap>;
  onClick: (
    modelMap: FirebaseDocument<ModelMap>,
    isCategoryOrModelError: boolean,
    filterError: string
  ) => void;
}

const TakeOffErrorList = ({ modelMap, onClick = () => {} }: IProps) => {
  const { categoryErrors, modelErrors, filterErrors, formatErrors } =
    modelMap.data;
  const labels = i18n.modelMaps.menuLateral;

  return (
    <>
      {categoryErrors &&
        categoryErrors.map((categoryErrors) => (
          <Row
            property={`${labels.category}: ${categoryErrors}`}
            onClick={() => onClick(modelMap, true, "")}
          />
        ))}
      {modelErrors &&
        modelErrors.map((modelErrors) => (
          <Row
            property={`${labels.model3d}: ${modelErrors.label}`}
            onClick={() => onClick(modelMap, true, "")}
          />
        ))}
      {filterErrors &&
        filterErrors.map((filterErrors) => (
          <Row
            property={`${labels.filter}: ${filterErrors}`}
            onClick={() => onClick(modelMap, false, filterErrors)}
          />
        ))}
      {formatErrors &&
        formatErrors
          .filter((x) => x.property)
          .map((formatErrors) => (
            <Row
              property={`${labels.properties}: [${formatErrors.property}]`}
              onClick={() => onClick(modelMap, false, "")}
            />
          ))}
    </>
  );
};

export default TakeOffErrorList;



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ModelMapItem/TakeOffErrorList.tsx